import {PDFDocument} from 'pdf-lib';


export async function pdfFirstPageToText(pdfBytes: any): Promise<{ textContent: string, pdfImageUrl: string }> {
    const pdfjs = await import('pdfjs-dist/legacy/build/pdf');
    // @ts-ignore
    pdfjs.GlobalWorkerOptions.workerSrc = await import('pdfjs-dist/legacy/build/pdf.worker.entry');

    const pdfDoc = await PDFDocument.load(pdfBytes);

    // Verificar se há páginas no PDF
    if (pdfDoc.getPageCount() > 0) {
        // Criar um novo documento PDF
        const newPdfDoc = await PDFDocument.create();

        // Copiar a primeira página do documento original para o novo documento
        const [firstPage] = await newPdfDoc.copyPages(pdfDoc, [0]);
        newPdfDoc.addPage(firstPage);

        // Serializar o novo documento para bytes
        const pdfBytes = await newPdfDoc.save();

        const pdf = await pdfjs.getDocument({ data: pdfBytes }).promise;
        const page = await pdf.getPage(1);
        const viewport = page.getViewport({ scale: 3 });
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        if (context) {
            context.fillStyle = '#FFFFFF';
            context.fillRect(0, 0, canvas.width, canvas.height);
        }

        await page.render({ canvasContext: context as any, viewport: viewport }).promise;
        // WebP preserva bordas de texto muito melhor que JPEG na mesma qualidade
        // (JPEG usa chroma subsampling, que borra dígitos finos tipo '9'/'0').
        // Com a mesma resolução (scale 3), WebP a 92% fica bem menor que o JPEG a
        // 90% que usávamos antes, então ainda cabe com folga no limite de 1MB do
        // DigitalOcean Functions. Nem todo navegador suporta exportar WebP via
        // canvas; se o navegador ignorar o mimeType pedido, toDataURL cai de volta
        // para PNG silenciosamente — nesse caso usamos JPEG como último recurso.
        let pdfImageUrl = canvas.toDataURL('image/webp', 0.92);
        if (!pdfImageUrl.startsWith('data:image/webp')) {
            pdfImageUrl = canvas.toDataURL('image/jpeg', 0.90);
        }

        // Extract text from the PDF using pdfjs-dist
        const loadingTask = pdfjs.getDocument({data: pdfBytes});
        return await loadingTask.promise.then(async (pdf) => {
            let textContent = '';
            for (let i = 0; i < pdf.numPages; i++) {
                const page = await pdf.getPage(i + 1);
                const textContentPage = await page.getTextContent();
                textContentPage.items.forEach((item: any) => {
                    textContent += item.str + ' ';
                });
            }
            return {textContent, pdfImageUrl};
        });
    }

    return { textContent: '', pdfImageUrl: '' };
}